import type { ILink, IPagePath } from "@contentful-api/types/contentful";

export const isPagePath = (link: ILink | IPagePath): link is IPagePath =>
    link.sys.contentType.sys.id === "pagePath";

export const withQueryParameters = (href: string, queryParameters?: string): string => {
    if (!queryParameters) return href;

    return `${href}${href.includes("?") ? "&" : "?"}${queryParameters}`;
};
